/**
 * Message status flow:
 * [Pending] Sent [DeliveredToCloud] [DeliveredToDevice] [Seen]
 */
export let MessageStatus = /*#__PURE__*/ function (MessageStatus) {
    MessageStatus[MessageStatus["Pending"] = 0] = "Pending";
    // Message is waiting in client for sending (using this you can implement delayed sending e.g. to omit mistakes)
    MessageStatus[MessageStatus["Sent"] = 1] = "Sent";
    // Message was sent do the cloud
    MessageStatus[MessageStatus["DeliveredToCloud"] = 2] = "DeliveredToCloud";
    // The cloud acknowledged the receipt of the message
    MessageStatus[MessageStatus["DeliveredToDevice"] = 3] = "DeliveredToDevice";
    // The message has been delivered to at least one client device
    MessageStatus[MessageStatus["Seen"] = 4] = "Seen";
    // The message was seen by the recipient
    MessageStatus[MessageStatus["UnSync"] = 5] = "UnSync";
    return MessageStatus;
}({});
